import { io, Socket } from 'socket.io-client'

let socket: Socket | null = null

type EventListener = (...args: any[]) => void
const listenerRegistry = new Map<string, Set<EventListener>>()

// Track if this is the first connection
let isFirstConnection = true

export const socketConnect = (token = '') => {
  if (!socket) {
    isFirstConnection = true
    socket = io(process.env.REACT_APP_ROOT_URL || '', {
      reconnectionAttempts: 5,
      reconnectionDelay: 5,
      timeout: 10000,
      auth: { token },
    })
  }
  // Always return the current socket instance (may have been updated by socketUpdateToken)
  return { socket }
}

export const socketUpdateToken = (newToken: string) => {
  // Disconnect and clear the current socket
  if (socket) {
    socket.disconnect()
    listenerRegistry.clear()
    socket = null
  }
  // Toggle reloadSocket flag to trigger reconnection in components
  const reloadSocket =
    localStorage.getItem('reloadSocket') === 'true' ? true : false
  localStorage.setItem('reloadSocket', `${!reloadSocket}`)
  // Dispatch custom event for same-tab updates (storage event only fires in other tabs)
  window.dispatchEvent(new Event('reloadSocket'))
}

export const socketDisconnect = () => {
  if (socket) {
    socket.disconnect()
    listenerRegistry.clear()
    socket = null
  }
}

export const socketConnectNew = (token = '') => {
  if (!socket) {
    isFirstConnection = true
    socket = io(process.env.REACT_APP_ROOT_URL || '', {
      reconnectionAttempts: 5,
      reconnectionDelay: 5,
      timeout: 10000,
      auth: { token },
    })
  } else {
    socketUpdateToken(token)
  }
  // Always return the current socket instance (may have been updated by socketUpdateToken)
  return { socket }
}
